import { Link } from 'react-router-dom';
import { articlePreviews } from '@/mocks/articles';

export default function ArticlePreview() {
  return (
    <section className="py-14 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-semibold tracking-wider uppercase text-primary-700 bg-primary-100 rounded-full mb-3">
            In-Depth Guides
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Basetao Spreadsheet Resources &amp; Articles
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Dive into our comprehensive guides covering everything from getting started to advanced shopping strategies with Basetao Spreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articlePreviews.map((article) => {
            const CardContent = (
              <>
                <div className="relative h-48 overflow-hidden bg-secondary-100">
                  <img
                    src={article.image}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-5 md:p-6">
                  <span className="inline-block px-2.5 py-1 text-[11px] font-semibold tracking-wider uppercase text-accent-700 bg-accent-100 rounded-full mb-3">
                    {article.category}
                  </span>
                  <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    {article.excerpt}
                  </p>
                  <span className="inline-flex items-center gap-1 text-sm font-semibold text-primary-600 whitespace-nowrap">
                    Read Article
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </>
            );

            if (article.slug === 'basetao-spreadsheet-guide-2026') {
              return (
                <Link
                  key={article.slug}
                  to="/basetao-spreadsheet-guide-2026"
                  className="group bg-background-50 border border-secondary-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer"
                >
                  {CardContent}
                </Link>
              );
            }

            if (article.internal) {
              return (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50 border border-secondary-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer"
                >
                  {CardContent}
                </Link>
              );
            }

            return (
              <a
                key={article.slug}
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="group bg-background-50 border border-secondary-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer"
              >
                {CardContent}
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}